import React from 'react';
import { Wizard } from "./Wizard";
import steps from "./Steps";
import { useStore, actions, loadInitialState } from './store';
import WithGoogleReCaptcha from './Hoc/WithGoogleReCaptcha';

const App = () => {
  const [iframe, setIframe] = useStore(state => [state.iframe, state.setIframe])
  const [staging, setStaging] = useStore(state => [state.staging, state.setStaging])
  const currentStep = useStore(state => state.currentStep)
  const setAdditionalFormData = useStore(state => state.setAdditionalFormData)
  const [isLoading, setIsLoading] = React.useState(true)
  const [isBlocked, setIsBlocked] = React.useState(false)


  React.useEffect(() => {
    if (window.self !== window.top) {
      setIframe(true)
      const script = document.querySelector('script[src*="googletagmanager.com"]')
      if (script) {
        script.remove()
      }

      function handleMessage(event) {
        if (!event.origin.includes('cookie-script')) {
          return
        }

        const data = event.data
        if (data.hasOwnProperty('documentName') || data.hasOwnProperty('currentLang')) {
          setAdditionalFormData({
            documentName: data.documentName,
            currentLang: data.currentLang
          })
          if(data.initialValue && data.initialValue.length > 0) {
            loadInitialState(JSON.parse(data.initialValue), data.itemId)
          } else {
            loadInitialState(null, data.itemId, { website: data.itemUrl })
          }

          if(currentStep.name === 'preview') {
            actions.handleWizardPrevStep()
          }
          setIsLoading(false)
        }
      }

      window.addEventListener('message', handleMessage)
      
      return () => {
        window.removeEventListener('message', handleMessage)
      }
    } else {
      if(window.location.href.includes('v2generator.cookie-script.com')) {
        setStaging(true)
        if(!window.location.search.includes('v2=v2')) {
          setIsBlocked(true)
        }
      }
      setIframe(false);
      setIsLoading(false);
    }

  }, [currentStep, isLoading])

  if((iframe && isLoading) || isBlocked) {
    return ('Loading...');
  }

  return (
    <WithGoogleReCaptcha apply={!iframe && !staging}>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <h1 className='text-center mt-3 mb-3'>Privacy Policy Generator</h1>
            <Wizard steps={steps} />
          </div>
        </div>
      </div>
    </WithGoogleReCaptcha>
  );
}

export default App;
